<template>
<div class="profile-menu">
  <div class="profile-menu__title">
    <a :href="profileLink" class="profile-menu__link">
      <img
        :src="avatarUrl"
        :class="['profile-menu__avatar', { 'profile-menu__avatar--default': avatarUrl === defaultAvatarUrl }]">
    </a>
    <CaretDown class="profile-menu__icon profile-menu__icon--hoverable profile-menu__icon--lowered" />
  </div>
  <ul class="profile-menu__list">
    <li class="profile-menu__list-item">
      <a class="profile-menu__list-link" :href="profileLink">Manage Profile</a>
    </li>
    <li class="profile-menu__list-item">
      <a class="profile-menu__list-link" @click="logout">Log out</a>
    </li>
  </ul>
</div>
</template>
<script setup lang="ts">
import CaretDown from '@/assets/CaretDown.svg'
import { logout } from '@/auth/sws'

const defaultAvatarUrl = 'https://static.serato.com/common/images/default-profile-picture.svg'
const profileLink = import.meta.env.VUE_APP_CLIENT_URI_MY_ACCOUNT

const props = defineProps<{
  avatarUrl: string
}>()

</script>
<style lang="scss">
.profile-menu {
  display: block;
  position: relative;

  &__title {
    display: flex;
    align-items: center;
    width: 55px;
    cursor: pointer;
    gap: 5px;
  }

  &__link {
    display: contents;
  }

  &__avatar{
    height: 40px;
    width: 40px;
    border-radius: 50%;
    border: 2px solid $white;

    &--default {
      border: 2px solid $grey-default-profile;
    }
  }

  &__icon {
    fill: $link-blue;
    transition: all 200ms $animationCurve;

    &--lowered {
      position: relative;
      top: 1px;
    }
  }

  &__list {
    left: -20px;
    visibility: hidden;
    opacity: 0;
    background-color: $grey-85;
    border-radius: 4px;
    margin-top: 12px;
    min-width: 180px;
    transition: all 200ms $animationCurve;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 20px 24px;
    position: absolute;
    list-style-type: none;
    z-index: 1;
  }

  &__list-item {
    cursor: pointer;
  }

  &__list-link {
    text-decoration: none;
    color: $link-blue;
    font-size: 14px;
    font-family: $font-medium;
  }
  
  &:hover {
    .profile-menu__list {
      opacity: 1;
      visibility: visible;
    }

    .profile-menu__icon--hoverable {
      fill: $white;
    }
  }
}
</style>
